import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // Для работы с параметрами URL и перенаправления
import { publicAPI } from './api'; // Импортируем publicAPI из файла api.js

const EmailVerification = () => {
  const { token } = useParams(); // Получаем токен из параметров URL
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        // Отправляем POST-запрос с токеном
        const response = await publicAPI.post(`/mail/verify/${token}`);

        if (response.status === 200) {
          // Если верификация успешна, перенаправляем на страницу логина
          navigate('/login', { state: { message: 'Verification successful!', messageType: 'success' } });
        }
      } catch (error) {
        const errorMessage = error.response?.data?.detail;

        // Проверка на уже верифицированный email
        if (errorMessage === 'Email is already verified') {
          navigate('/login', { state: { message: 'Email is already verified!', messageType: 'success' } });
        }
        // Проверка на отключенный аккаунт
        else if (errorMessage === 'Your account is disabled') {
          navigate('/login', { state: { message: 'Your account is disabled.', messageType: 'error' } });
        }
        // Для всех других ошибок
        else {
          navigate('/verify', { state: { error: 'Token expired or invalid. Please request a new verification link.' } });
        }
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Verifying your email...
        </h2>
      </div>
    </div>
  );
};

export default EmailVerification;
